import { NavLink, Outlet } from "react-router-dom";

const tabs = [
  ["/admin/overview", "总览"],
  ["/admin/users", "用户与积分"],
  ["/admin/codes", "卡密"],
  ["/admin/tasks", "任务"],
  ["/admin/diagnostics", "运行诊断"],
] as const;

export function AdminLayout() {
  return (
    <div className="admin-workspace">
      <nav className="admin-tabs" aria-label="管理控制台导航">
        {tabs.map(([to, label]) => <NavLink key={to} to={to} className={({ isActive }) => isActive ? "is-active" : ""}>{label}</NavLink>)}
      </nav>
      <Outlet />
    </div>
  );
}

